<!--
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-06-01 16:01:31
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-01-15 10:38:41
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WaterMark from './utils/waterMark.js'
export default {
  name: 'App',
  computed: {
    ...mapGetters(['name', 'userinfo'])
  },
  watch: {

    name: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          // this.showMark()
        }
      },
      immediate: true,
      deep: true
    }

  },
  mounted() {
    console.log('App mounted')
    // 绑定到实例以便正确移除
    this.boundBeforeunloadHandler = e => this.beforeunloadHandler(e)
    window.addEventListener('beforeunload', this.boundBeforeunloadHandler)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.boundBeforeunloadHandler)
  },
  methods: {
    beforeunloadHandler(e) {
      // 白名单：需要在页面刷新时保持的sessionStorage项
      // 作者: domiyoung
      const protectedKeys = ['isArchiveEnv']
      const protectedData = {}

      // 保存白名单中的项
      protectedKeys.forEach(key => {
        const value = sessionStorage.getItem(key)
        if (value !== null) {
          protectedData[key] = value
        }
      })

      // 清空sessionStorage
      sessionStorage.clear()

      // 恢复受保护的项
      Object.keys(protectedData).forEach(key => {
        sessionStorage.setItem(key, protectedData[key])
      })
    },
    showMark() {
      new WaterMark({
        watermark_rows: 100, // 水印行数
        watermark_txt: this.name + ' — J' + this.userinfo.id, // 水印内容
        watermark_width: 150, // 水印宽度
        watermark_color: '#aaaaaa', // 字体颜色
        watermark_fontsize: '18px', // 字体大小
        watermark_angle: 30, // 字体倾斜角度
        watermark_height: 60, // 水印长度
        watermark_y_space: 60, // Y轴间隔
        watermark_alpha: '0.18' // 水印字体透明度
      })
    }

  }
}

</script>
